const en = {
	submit: 'Submit',
	back: 'Back',
	cancel: 'Cancel',
	ok: 'OK',
	clear: 'Clear',
	to: 'To',
	add: 'Add',
	month: 'Month',
	noAddiction: 'No Addiction',
	informationCompletionGuide: 'Information of completion guide',
	editTheDocument: 'Edit the document',
	dashboard: 'Dashboard',
	customerCount: 'Customer count:',
	numberGuaranteesNearMaturity: 'Number guarantees near maturity:',
	rulesAndRegulations: 'Rules and regulations',
	ongoingFiles: 'Ongoing files',
	support: 'Support',
	today: 'Today',
	servicesManagement: 'Services',
	allServices: 'All Services',
	myService: 'My Service',
	servicesArchive: 'Services Archive',
	setting: 'Setting',
	documents: 'Documents',
	loan: 'Loan',
	bill: 'Bill',
	adequacyCapital: 'Adequacy of Capital',
	fundManagementPanel: 'Fund Management Panel',
	warranty: 'Warranty',
	evaluation: 'Evaluation',
	inbox: 'Inbox',
	closedTickets: 'Closed Tickets',
	userName: 'Username',
	password: 'Password',
	active: 'Active',
	gender: 'Gender',
	male: 'Male',
	female: 'Female',
	status: 'Status',
	subject: 'Subject',
	priority: 'Priority',
	title: 'Title',
	customerName: 'Customer Name',
	low: 'Low',
	medium: 'Medium',
	high: 'High',
	archive: 'Archive',
	current: 'Current',
	ongoing: 'Ongoing',
	applicant: 'Applicant',
	nationalId: 'National Id',
	requestNumber: 'Request Number',
	serviceType: 'Service Type',
	lastUpdateTime: 'Last Update Time',
	contractNumber: 'Contract Number',
	amount: 'Amount',
	requestedAmount: 'Requested Amount',
	requestStatus: 'Request Status',
	calculatingBasisDate: 'Calculating Basis Date',
	paymentStepsCount: 'Payment Steps Count',
	source: 'Source',
	tender: 'Tender',
	prepaidContract: 'Prepaid Contract',
	goodFulfillmentOfObligations: 'Good Fulfillment of Obligations',
	credit: 'Credit',
	vajhoZeman: 'Vajh AlZeman',
	custom: 'Custom',
	endDate: 'End Date',
	warrantyDays: 'Warranty Days',
	technical: 'Technical',
	financial: 'Financial',
	other: 'Other',
	waitingForResponse: 'Waiting For Response',
	hasBeenResponded: 'Has Been Responded',
	registrationDate: 'Registration Date',
	getCompleteExcel: 'Complete Excel',
	searchTicketsByType: 'Search tickets by type',
	download: 'Download',
	columns: 'Columns',
	column: 'Column',
};
export default en;
